<template>
  <div class="share-wrap no-px2rem">
    <section class="share">
      <div class="icons" :class="{'ipad-icons': isIPad}">
        <div class="icon" @click.stop="plantformClick(plantform)" v-for="plantform in plantforms" :key="plantform.name">
          <img :src="plantform.icon" />
        </div>
        <div class="icon" @click.stop="systemEntrance">
          <img :src="moreIconUrl" />
        </div>
      </div>
    </section>
    <!-- 分享成功 -->
    <half-popup
        :isShow="isShow"
        @clickMask="clickMask"
    >
      <div slot="content">
        <div class="share-status">
          <img src="../../../../assets/images/xtc/success.png" />
          <p class="share-title">{{$t('Share Success')}}</p>
          <p class="share-explain">{{$t('You can continue to share with more friends and get more rewards ~')}}</p>
        </div>
      </div>
    </half-popup>
    <LoadingMask v-show="loading"></LoadingMask>
  </div>
</template>
<script>
  import LoadingMask from '@/components/loading/loading-mask'
  import { PLATFORM_POINT, PLATFORM_ICON_MAP, PLATFORM_BRIDGE_METHOD } from '@/components/share/platformConfig'
  import HalfPopup from '@/components/half-popup/index'
  const moreIconUrl = 'https://img0.didiglobal.com/static/soda_static/m/act/static/img/more@2x.png'
  export default {
    components: { LoadingMask, HalfPopup },
    props: {
      config: {
        type: Object,
        default: () => {}
      },
      shortLink: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        isShow: false,
        moreIconUrl
      }
    },
    computed: {
      plantforms () {
        const { config } = this.config
        const { order } = this.config
        let res = Object.entries(config)
          .filter(conf => {
            let [key] = conf
            return order.includes(key)
          })
          .map(conf => {
            let [key, value] = conf
            return {
              name: order.includes(key) ? key : '',
              icon: PLATFORM_ICON_MAP[key] || '',
              bridge: PLATFORM_BRIDGE_METHOD[key] || '',
              config: value
            }
          })
        return res
      }
    },
    methods: {
      plantformClick (plantform) {
        let config = plantform.config || this.config.config.common
        this.shareCommon(plantform.name.toLowerCase(), plantform.bridge, config)
      },
      async systemEntrance () {
        // let config = this.config.config.systemEntrance || this.config.config.common
        // await this.shareCommon('systemEntrance', 'shareSystemEntrance', config)
        // 因下架Twitter分享渠道，需要限制弹出的渠道，不使用系统的所有分享渠道
        this.shareEntrance()
      },
      async sms () {
        let config = this.config.config.sms || this.config.config.common
        await this.shareCommon('sms', 'shareSMS', config)
      },
      async email () {
        let config = this.config.config.email || this.config.config.common
        await this.shareCommon('email', 'shareEmail', config)
      },
      async shareCommon (plantform, bridgMethod, config) {
        this.$emit('trackShareClick', PLATFORM_POINT[plantform.toLowerCase()] || plantform)
        let shareConfig = {...config}
        // 分享whatsapp、facebook、Mycenter、调面板都不支持回调, 不做回调处理
        await this.SodaBridge(bridgMethod, {
          url: shareConfig.url,
          title: shareConfig.title,
          content: shareConfig.content,
          icon: shareConfig.icon
        })
        // .then((res) => {
        //   if (res && res.errno === 0) {
        //     this.isShow = true
        //   }
        // })
      },
      clickMask () {
        this.isShow = false
      },
      async shareEntrance() {
        const { config } = this.config
        const { order } = this.config
        // 手动加上公共渠道分享
        const COMMON_CHANNELS = ['sms', 'email']
        const shareOrder = order ? [...order, ...COMMON_CHANNELS] : COMMON_CHANNELS
        const buttons = shareOrder.map((o) => {
          const confi = config[o]
          return {
            type: PLATFORM_BRIDGE_METHOD[o] || '',
            data: confi ? confi : config.common
          }
        })
        await this.SodaBridge("initEntrance", {
          buttons
        })
        await this.SodaBridge("invokeEntrance"), {
          buttons
        }
        this.$emit('trackShareButtonClick', 4)
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
$conversion = 0.5859375px
.share-status {
  color: #000000;
  display flex;
  align-items: center;
  justify-items: flex-start;
  flex-direction: column;
  img {
    width: 288px;
    height: 288px;
  }
  .share-title {
    margin-top: 10px;
    height: 50px;
    line-height: 50px;
    font-family: 'Aspira Medium';
    font-size: 44px;
    text-align: center;
    font-weight: 500;
  }
  .share-explain {
    margin-top: 24px;
    width: 555px;
    height: 68px;
    font-family: 'Aspira Regular';
    font-size: 28px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    line-height: 34px;
    font-weight: 400;
  }
}
  .share-wrap.no-px2rem
    .share
      .icons
        padding 0 15px 15px
        font-size 12px
        display flex
        justify-content center
        flex-wrap wrap
        &.morethan
          .icon
            margin-left 29px
        .icon
          padding-top 15px
          margin-left 35px
          img
            width 36px
            height 36px
        .icon:first-child
          margin-left 0
      .ipad-icons
        padding 0 15px
</style>
